var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149.65625pt",
    height: "373.57422pt",
    viewBox: "0 0 149.65625 373.57422",
    id: "svg572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.3125,2.828125 C 2.226562,3.015625 2.039062,3.109375 1.75,3.109375 1.664062,3.109375 1.582031,3.09375 1.5,3.0625 L 1.078125,2.953125 C 0.597656,2.828125 0.28125,2.578125 0.125,2.203125 0.0390625,2.015625 0,1.796875 0,1.546875 V 0.71875 C 0,0.582031 0.0703125,0.515625 0.21875,0.515625 c 0.132812,0 0.203125,0.066406 0.203125,0.203125 v 0.953125 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 1.5,2.625 c 0.09375,0.019531 0.175781,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.75 c 0,-0.148438 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070312 0.21875,0.21875 v 0.5 c 0,0.257812 0.101563,0.476562 0.3125,0.65625 C 2.992188,3 3.101562,3.0625 3.21875,3.09375 c 0.070312,0.00781 0.132812,0.015625 0.1875,0.015625 0.300781,0 0.453125,-0.171875 0.453125,-0.515625 V 1.765625 c 0,-0.148437 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070313 0.21875,0.21875 v 0.9375 c 0,0.332031 -0.152344,0.582031 -0.453125,0.75 -0.136719,0.0625 -0.277344,0.09375 -0.421875,0.09375 -0.0625,0 -0.132813,-0.00781 -0.203125,-0.015625 C 2.75,3.40625 2.445312,3.171875 2.3125,2.828125 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,1.671875 c 0,0.4375 0.21875,0.710937 0.65625,0.828125 L 1.5,2.625 c 0.082031,0.019531 0.164062,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.453125 l -1.0625,-0.28125 C 1.003906,1.148438 0.945312,1.140625 0.90625,1.140625 0.769531,1.140625 0.65625,1.1875 0.5625,1.28125 0.46875,1.382812 0.421875,1.515625 0.421875,1.671875 Z M 0,1.546875 c 0,-0.304687 0.15625,-0.542969 0.46875,-0.71875 0.132812,-0.085937 0.273438,-0.125 0.421875,-0.125 0.0625,0 0.117187,0.007813 0.171875,0.03125 l 1.296875,0.34375 c 0.476563,0.125 0.878906,0.335937 1.203125,0.640625 0.351562,0.332031 0.59375,0.769531 0.71875,1.3125 0.00781,0.019531 0.015625,0.039062 0.015625,0.0625 0,0.132812 -0.074219,0.203125 -0.21875,0.203125 C 3.953125,3.296875 3.882812,3.25 3.875,3.15625 3.84375,2.914062 3.753906,2.675781 3.609375,2.4375 3.335938,2 2.992188,1.722656 2.578125,1.609375 V 2.25 C 2.578125,2.488281 2.5,2.6875 2.34375,2.84375 2.1875,3.007812 1.984375,3.09375 1.734375,3.09375 1.648438,3.09375 1.570312,3.082031 1.5,3.0625 L 1.078125,2.953125 C 0.578125,2.816406 0.253906,2.570312 0.109375,2.21875 0.0351562,2.039062 0,1.816406 0,1.546875 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.109375,3.03125 0.09375,1.796875 C 0.03125,1.753906 0,1.691406 0,1.609375 0,1.546875 0.0195312,1.492188 0.0625,1.453125 0.113281,1.410156 0.164062,1.390625 0.21875,1.390625 l 3.859375,0.15625 c 0.144531,0 0.21875,0.066406 0.21875,0.203125 0,0.15625 -0.078125,0.234375 -0.234375,0.234375 L 1.015625,1.84375 2.90625,3.015625 C 2.96875,3.046875 3,3.101562 3,3.1875 3,3.320312 2.9375,3.394531 2.8125,3.40625 L 0.984375,3.546875 4.171875,5.125 c 0.082031,0.039062 0.125,0.101562 0.125,0.1875 0,0.144531 -0.074219,0.21875 -0.21875,0.21875 -0.03125,0 -0.0625,-0.00781 -0.09375,-0.015625 L 0.109375,3.59375 C 0.0351562,3.550781 0,3.488281 0,3.40625 0,3.257812 0.0664062,3.1875 0.203125,3.1875 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,2.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.921875,1.046875 c 0.101563,0.03125 0.15625,0.101563 0.15625,0.21875 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.023437,0 -0.042969,0 -0.0625,0 L 0.421875,1 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.140625,2.640625 V 1.46875 L 0.421875,1 v 1.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.859375,1.03125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.53125 C 4.296875,3.675781 4.222656,3.75 4.078125,3.75 3.929688,3.75 3.859375,3.675781 3.859375,3.53125 V 1.921875 l -1.28125,-0.34375 v 1.0625 c 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.148437,0 -0.21875,-0.070312 -0.21875,-0.203125 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.078125,1.53125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.15625 c 0,0.21875 -0.09375,0.410156 -0.28125,0.578125 C 3.828125,3.910156 3.617188,4 3.390625,4 3.328125,4 3.269531,3.992188 3.21875,3.984375 L 1.078125,3.40625 C 0.359375,3.207031 0,2.738281 0,2 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 Z M 3.859375,1.921875 0.421875,1 v 1.109375 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 3.21875,3.53125 C 3.269531,3.539062 3.320312,3.546875 3.375,3.546875 3.519531,3.546875 3.632812,3.5 3.71875,3.40625 3.8125,3.3125 3.859375,3.1875 3.859375,3.03125 Z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.71875,4.28125 H 0 V 0.25 c 0.175781,0 0.347656,0.03125 0.515625,0.09375 0.28125,0.101562 0.550781,0.265625 0.8125,0.484375 C 1.597656,1.054688 1.90625,1.382812 2.25,1.8125 c 0.539062,0.664062 0.96875,1.113281 1.28125,1.34375 0.320312,0.238281 0.625,0.359375 0.90625,0.359375 0.300781,0 0.550781,-0.109375 0.75,-0.328125 C 5.394531,2.976562 5.5,2.703125 5.5,2.359375 5.5,2.003906 5.390625,1.71875 5.171875,1.5 4.960938,1.28125 4.664062,1.171875 4.28125,1.171875 L 4.359375,0.40625 C 4.929688,0.457031 5.367188,0.65625 5.671875,1 5.972656,1.34375 6.125,1.800781 6.125,2.375 6.125,2.957031 5.957031,3.421875 5.625,3.765625 5.300781,4.109375 4.898438,4.28125 4.421875,4.28125 4.179688,4.28125 3.941406,4.226562 3.703125,4.125 3.472656,4.03125 3.226562,3.863281 2.96875,3.625 2.707031,3.394531 2.347656,3.015625 1.890625,2.484375 1.515625,2.023438 1.257812,1.734375 1.125,1.609375 0.988281,1.484375 0.851562,1.378906 0.71875,1.296875 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3,0.359375 c 0.726562,0 1.3125,0.070313 1.75,0.21875 0.4375,0.144531 0.773438,0.363281 1.015625,0.65625 C 6.003906,1.523438 6.125,1.894531 6.125,2.34375 6.125,2.664062 6.054688,2.953125 5.921875,3.203125 5.785156,3.453125 5.59375,3.65625 5.34375,3.8125 5.101562,3.96875 4.800781,4.09375 4.4375,4.1875 4.082031,4.28125 3.601562,4.328125 3,4.328125 2.289062,4.328125 1.710938,4.253906 1.265625,4.109375 0.828125,3.960938 0.488281,3.742188 0.25,3.453125 0.0078125,3.160156 -0.109375,2.789062 -0.109375,2.34375 -0.109375,1.75 0.101562,1.285156 0.53125,0.953125 1.03125,0.554688 1.851562,0.359375 3,0.359375 Z M 3,1.125 C 2,1.125 1.332031,1.238281 1,1.46875 0.675781,1.707031 0.515625,2 0.515625,2.34375 c 0,0.34375 0.164063,0.628906 0.5,0.859375 C 1.347656,3.441406 2.007812,3.5625 3,3.5625 4.007812,3.5625 4.675781,3.441406 5,3.203125 5.332031,2.972656 5.5,2.679688 5.5,2.328125 5.5,1.984375 5.351562,1.710938 5.0625,1.515625 4.6875,1.253906 4,1.125 3,1.125 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0.625 h 6.09375 v 0.8125 h -5.375 v 3 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g573",
    transform: "translate(-306.53125,-11.09375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,6.15333e-4 h -34.71875 m -5.28125,0 h -5.119792 m -5.28125,0 h -5.119791 m -5.119792,0 H -86.5625 m -5.276042,0 h -5.119791 m -5.119797,0 h -5.28125 m -5.11979,0 h -25.92187 m -5.11979,0 h -5.28125 m -5.11979,0 h -5.27605",
    transform: "matrix(0.75,0,0,0.75,456,384.48001)",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 443.68229,512.64063 H 408.95833 V 484",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00165767,2.08667e-4 V -5.281041 m 0,-5.119792 v -5.119792 m 0,-5.28125 v -25.916666 m 0,-5.119792 v -5.119792 m 0,-5.28125 v -5.119791 m 0,-5.28125 v -25.760417 m 0,-5.281247 v -5.11979 m 0,-5.27605 v -5.11979 m 0,-5.11979 v -25.92187 m 0,-5.28125 v -5.1198 m 0,-5.11979 v -5.28125 m 0,-5.11979 v -25.91667 m 0,-5.11979 v -5.28125 m 0,-5.11979 V -222.88 m 0,-5.11979 v -25.92188 m 0,-5.11979 v -5.27604 m 0,-5.125 v -5.11979 m 0,-5.27604 v -25.92188 m 0,-5.11979 v -5.11979 m 0,-5.28125 v -5.11979 m 0,-5.28125 v -25.91667 m 0,-5.11979 v -5.11979 m 0,-5.28125 v -5.11979 m 0,-5.1198 v -25.92187 m 0,-5.28125 v -5.11979 m 0,-5.27604 v -5.1198",
    transform: "matrix(0.75,0,0,0.75,306.71999,359.16)",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 408.95833,43.682297 V 15.041672 h 34.72396",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,0.001672 H 5.278137 m 5.119792,0 h 5.28125 m 5.119791,0 h 25.921875 m 5.119792,0 h 5.28125 m 5.119792,0 h 5.119791 m 5.276042,0 h 25.921875 m 5.119793,0 h 5.11979 m 5.28125,0 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,336.59999,11.279996)",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 573.28125,15.041672 H 608 v 28.640625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,0.00208967 V 5.121881 m 0,5.276042 v 5.119792 m 0,5.28125 V 46.72084 m 0,5.119791 v 5.119792 m 0,5.28125 v 5.119792 m 0,5.119791 v 25.916667 m 0,5.281247 v 5.11979 m 0,5.28125 v 5.1198 m 0,5.11979 v 25.92187 m 0,5.27604 v 5.1198 m 0,5.125 v 5.27604 m 0,5.11979 v 25.92187 m 0,5.1198 v 5.28125 m 0,5.11979 v 5.28125 m 0,5.11979 v 25.91667 m 0,5.11979 v 5.28125 m 0,5.11979 v 5.11979 m 0,5.28125 v 25.92188 m 0,5.11979 v 5.11979 m 0,5.27604 v 5.11979 m 0,5.28125 v 25.76042 m 0,5.28125 v 5.11979 m 0,5.28125 v 5.11979 m 0,5.11979 v 25.91667 m 0,5.28125 v 5.11979 m 0,5.11979 v 5.28125",
    transform: "matrix(0.75,0,0,0.75,456,36.599995)",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 608,484 v 28.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456,11.28125 -0.23828,10.917969 V 11.28125 Z m 0,0",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456,11.28125 v 10.917969 h -0.23828 z m 0,0",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 455.76172,22.078125 -1.5625,0.121094 v -0.121094 z m 0,0",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 455.76172,22.078125 v 0.121094 h -1.5625 z m 0,0",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 454.19922,20.640625 -0.23828,1.558594 v -1.558594 z m 0,0",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 454.19922,20.640625 v 1.558594 h -0.23828 z m 0,0",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 448.44141,13.078125 447,13.199219 v -0.121094 z m 0,0",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 448.44141,13.078125 v 0.121094 H 447 Z m 0,0",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 455.76172,11.28125 447,11.398438 V 11.28125 Z m 0,0",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 455.76172,11.28125 v 0.117188 H 447 Z m 0,0",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 447,11.28125 -0.23828,1.917969 V 11.28125 Z m 0,0",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 447,11.28125 v 1.917969 h -0.23828 z m 0,0",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,0.001672 H 12.320007 m -12,0.15625 h 11.682292 m 0.317708,-0.15625 V 14.558964 M 12.002299,0.157922 v 14.239583 m 0.317708,0.161459 h -2.71875 m 2.401042,-0.161459 H 9.918965 m -0.317708,0.161459 v -2.078125 m 0.317708,1.916666 V 12.480839 M 0.00229867,0.001672 V 2.558964 M 0.320007,0.157922 V 2.397505 M 0.00229867,2.558964 H 2.241882",
    transform: "matrix(0.75,0,0,0.75,446.75999,11.279996)",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 596,17.437505 h 1.92187 v 0.161459",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,8.38667e-4 H -0.318726 M -3.360393,-9.921036 v 0.963541 m 0,0.317709 v 0.958333 m 0,0.161458 v 0.958334 m 0,0.322916 v 0.958334 m 0,0.322916 v 0.958334 m 0,0.161458 v 0.958333",
    transform: "matrix(0.75,0,0,0.75,454.19998,20.639996)",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 602.23958,24.958339 v 0.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.002297 H 0.95813 m 0.161458,0 h 0.958334 m 0.322916,0 h 0.958334 m 0.322916,0 h 0.958334 m 0.161458,0 h 0.958333 m 0.317709,0 h 0.963541",
    transform: "matrix(0.75,0,0,0.75,447.84,20.759996)",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 604.31771,27.682297 h 0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.71875,11.28125 0.12109,10.917969 V 11.28125 Z m 0,0",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.71875,11.28125 v 10.917969 h 0.12109 z m 0,0",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,22.078125 1.67969,0.121094 v -0.121094 z m 0,0",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,22.078125 v 0.121094 h 1.67969 z m 0,0",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 308.51953,20.640625 0.12109,1.558594 v -1.558594 z m 0,0",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 308.51953,20.640625 v 1.558594 h 0.12109 z m 0,0",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 314.28125,13.078125 1.4375,0.121094 v -0.121094 z m 0,0",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 314.28125,13.078125 v 0.121094 h 1.4375 z m 0,0",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,11.28125 8.87891,0.117188 V 11.28125 Z m 0,0",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,11.28125 v 0.117188 h 8.87891 z m 0,0",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 315.71875,11.28125 0.12109,1.917969 V 11.28125 Z m 0,0",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 315.71875,11.28125 v 1.917969 h 0.12109 z m 0,0",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.001672 H -12.161662 m 12,0.15625 h -11.838541 m -0.161459,-0.15625 v 14.557292 m 0.161459,-14.401042 v 14.239583 m -0.161459,0.161459 h 2.5625 m -2.401041,-0.161459 h 2.239583 m 0.161458,0.161459 V 12.480839 M -9.76062,14.397505 V 12.480839 M -2.03333e-4,0.001672 V 2.558964 M -0.161662,0.157922 V 2.397505 M -2.03333e-4,2.558964 H -2.078328",
    transform: "matrix(0.75,0,0,0.75,315.84,11.279996)",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 420.95833,17.437505 h -1.91666 v 0.161459",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,8.38667e-4 H 0.160848 M 3.202515,-9.921036 v 0.963541 m 0,0.317709 v 0.958333 m 0,0.161458 v 0.958334 m 0,0.322916 v 0.958334 m 0,0.322916 v 0.958334 m 0,0.161458 v 0.958333",
    transform: "matrix(0.75,0,0,0.75,308.51999,20.639996)",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 414.5625,24.958339 v 0.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,0.002297 H -0.799785 m -0.317708,0 h -0.963542 m -0.161458,0 h -0.958333 m -0.317709,0 h -0.963541 m -0.317709,0 h -0.958333 m -0.161458,0 H -6.87791",
    transform: "matrix(0.75,0,0,0.75,314.75999,20.759996)",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 412.47917,27.682297 h -0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456,384.48047 -0.23828,-10.92188 v 10.92188 z m 0,0",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456,384.48047 v -10.92188 h -0.23828 z m 0,0",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 455.76172,373.67969 -1.5625,-0.1211 v 0.1211 z m 0,0",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 455.76172,373.67969 v -0.1211 h -1.5625 z m 0,0",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 454.19922,375.12109 -0.23828,-1.5625 v 1.5625 z m 0,0",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 454.19922,375.12109 v -1.5625 h -0.23828 z m 0,0",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 448.44141,382.67969 447,382.44141 v 0.23828 z m 0,0",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 448.44141,382.67969 v -0.23828 H 447 Z m 0,0",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 455.76172,384.48047 447,384.35937 v 0.1211 z m 0,0",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 455.76172,384.48047 v -0.1211 H 447 Z m 0,0",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 447,384.48047 -0.23828,-2.03906 v 2.03906 z m 0,0",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 447,384.48047 v -2.03906 h -0.23828 z m 0,0",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,6.15333e-4 H 12.320007 m -12,-0.161458333 H 12.002299 M 12.320007,6.15333e-4 V -14.561885 m -0.317708,14.401042 v -14.239583 m 0.317708,-0.161459 h -2.71875 m 2.401042,0.161459 H 9.918965 m -0.317708,-0.161459 v 2.083334 m 0.317708,-1.921875 v 1.921875 M 0.00229867,6.15333e-4 V -2.718135 M 0.320007,-0.160843 V -2.400426 M 0.00229867,-2.718135 H 2.241882",
    transform: "matrix(0.75,0,0,0.75,446.75999,384.48001)",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 596,510.23959 h 1.92187 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,0.00145967 H -0.318726 M -3.360393,9.761876 V 8.959793 m 0,-0.317708 V 7.678543 m 0,-0.15625 V 6.558751 m 0,-0.317708 V 5.277501 m 0,-0.317708 V 4.00146 m 0,-0.161459 V 2.881668",
    transform: "matrix(0.75,0,0,0.75,454.19998,375.12)",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 602.23958,502.71875 v -0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,5.33333e-6 H 0.95813 m 0.161458,0 h 0.958334 m 0.322916,0 h 0.958334 m 0.322916,0 h 0.958334 m 0.161458,0 h 0.958333 m 0.317709,0 h 0.963541",
    transform: "matrix(0.75,0,0,0.75,447.84,375)",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 604.31771,500 h 0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.71875,384.48047 0.12109,-10.92188 v 10.92188 z m 0,0",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.71875,384.48047 v -10.92188 h 0.12109 z m 0,0",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,373.67969 1.67969,-0.1211 v 0.1211 z m 0,0",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,373.67969 v -0.1211 h 1.67969 z m 0,0",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 308.51953,375.12109 0.12109,-1.5625 v 1.5625 z m 0,0",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 308.51953,375.12109 v -1.5625 h 0.12109 z m 0,0",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 314.28125,382.67969 1.4375,-0.23828 v 0.23828 z m 0,0",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 314.28125,382.67969 v -0.23828 h 1.4375 z m 0,0",
    id: "path79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,384.48047 8.87891,-0.1211 v 0.1211 z m 0,0",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 306.83984,384.48047 v -0.1211 h 8.87891 z m 0,0",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 315.71875,384.48047 0.12109,-2.03906 v 2.03906 z m 0,0",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 315.71875,384.48047 v -2.03906 h 0.12109 z m 0,0",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,6.15333e-4 H -12.161662 m 12,-0.161458333 H -12.000203 M -12.161662,6.15333e-4 V -14.561885 m 0.161459,14.401042 v -14.239583 m -0.161459,-0.161459 h 2.5625 m -2.401041,0.161459 h 2.239583 m 0.161458,-0.161459 v 2.083334 m -0.161458,-1.921875 v 1.921875 M -2.03333e-4,6.15333e-4 V -2.718135 M -0.161662,-0.160843 V -2.400426 M -2.03333e-4,-2.718135 H -2.078328",
    transform: "matrix(0.75,0,0,0.75,315.84,384.48001)",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 420.95833,510.23959 h -1.91666 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,0.00145967 H 0.160848 M 3.202515,9.761876 V 8.959793 m 0,-0.317708 V 7.678543 m 0,-0.15625 V 6.558751 m 0,-0.317708 V 5.277501 m 0,-0.317708 V 4.00146 m 0,-0.161459 V 2.881668",
    transform: "matrix(0.75,0,0,0.75,308.51999,375.12)",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 414.5625,502.71875 v -0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,5.33333e-6 H -0.799785 m -0.317708,0 h -0.963542 m -0.161458,0 h -0.958333 m -0.317709,0 h -0.963541 m -0.317709,0 h -0.958333 m -0.161458,0 H -6.87791",
    transform: "matrix(0.75,0,0,0.75,314.75999,375)",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 412.47917,500 h -0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 511.52083,112.95834 v 97.76041 h -6.08333 v -97.76041 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00166033 -0.479777,-0.642285 -1.28186,-1.121452 -2.078735,-1.43916 l -0.802083,-0.161459 -0.796875,0.161459 -0.802084,0.317708 -0.802083,0.479167 -0.479167,0.64062467",
    transform: "matrix(0.75,0,0,0.75,383.51999,84.719995)",
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,-0.00124567 0.478119,0.639379 1.280202,1.118546 2.082286,1.441463 2.879161,1.597713 3.681244,1.441463 4.478119,1.118546 5.280202,0.639379 5.759369,-0.00124567",
    transform: "matrix(0.75,0,0,0.75,379.2,158.04)",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 508.47917,112.95834 v 97.76041",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path253"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g253"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 384.95551,
    y: 107.51762,
    id: "use253"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 5429.1592,-19053.851 c 9.2251,4.228 13.8376,13.453 13.8376,27.675 0,4.228 -0.7687,8.264 -2.3063,12.3 l -5.3813,20.756 c -6.15,23.64 -18.4501,39.207 -36.9003,46.895 -9.2251,4.228 -19.9877,6.15 -32.2879,6.15 h -40.7441 c -6.7266,0 -9.9939,-3.46 -9.9939,-10.763 0,-6.534 3.2673,-9.994 9.9939,-9.994 h 46.8942 c 9.2251,0 17.6814,-3.075 25.369,-9.225 8.072,-6.15 13.4533,-13.838 16.1439,-23.063 l 5.3813,-20.756 c 0.961,-4.613 1.5375,-8.649 1.5375,-12.3 0,-12.685 -8.8407,-19.219 -26.1377,-19.219 h -18.4502 c -7.3032,0 -10.7626,-3.46 -10.7626,-10.763 0,-7.111 3.4594,-10.762 10.7626,-10.762 h 24.6002 c 12.6845,0 23.4472,-4.997 32.2879,-15.376 4.6125,-4.996 7.6875,-10.378 9.2251,-16.143 0.3843,-3.46 0.7687,-6.535 0.7687,-9.226 0,-14.798 -8.4563,-22.293 -25.369,-22.293 h -40.7441 c -7.3032,0 -10.7627,-3.46 -10.7627,-10.763 0,-7.111 3.4595,-10.763 10.7627,-10.763 h 46.1254 c 16.3361,0 28.6362,7.496 36.9004,22.294 3.075,6.727 4.6125,13.646 4.6125,20.757 0,3.075 -0.3843,6.534 -0.7687,9.994 -6.1501,23.062 -17.6815,38.053 -34.5941,44.588 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path254"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g254"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 384.95551,
    y: 110.63759,
    id: "use254"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 5525.6383,-18960.832 c 21.5252,0 34.9784,-10.762 40.7441,-32.288 l 6.1501,-20.756 c 0.9609,-4.036 1.5375,-8.072 1.5375,-12.3 0,-12.685 -8.8407,-19.219 -26.1378,-19.219 h -33.0565 l -13.8377,52.275 c -1.1531,3.652 -1.5375,6.535 -1.5375,8.457 0,6.726 2.3063,12.3 6.9188,16.912 4.9969,4.613 11.5314,6.919 19.219,6.919 z m -6.1501,20.757 c -14.9908,0 -26.7143,-7.688 -35.3628,-23.063 -4.2282,-6.535 -6.1501,-13.453 -6.1501,-20.757 0,-3.075 0.3844,-5.765 1.5375,-8.456 l 16.9127,-63.807 c 6.15,-23.447 16.5283,-43.242 31.519,-59.194 16.3361,-17.297 37.8614,-29.213 64.5757,-35.363 0.9609,-0.384 1.9219,-0.769 3.075,-0.769 6.5345,0 9.9939,3.652 9.9939,10.763 0,6.15 -2.3063,9.609 -6.9189,9.994 -11.9157,1.537 -23.6393,5.958 -35.3628,13.069 -21.5252,13.453 -35.1707,30.366 -40.7442,50.738 h 31.5191 c 11.7236,0 21.5252,3.843 29.2128,11.531 8.0719,7.688 12.3001,17.681 12.3001,29.982 0,4.228 -0.5766,8.072 -1.5375,11.531 l -5.3813,20.756 c -6.7266,24.601 -18.8346,40.552 -36.1316,47.663 -8.8407,3.652 -19.7955,5.382 -33.0566,5.382 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path255"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g255"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 384.95551,
    y: 113.63756,
    id: "use255"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 5740.1217,-19043.858 -60.7319,99.17 c -2.1141,3.075 -5.1891,4.613 -9.2251,4.613 -3.075,0 -5.7657,-0.961 -7.6876,-3.075 -2.1141,-2.499 -3.075,-4.997 -3.075,-7.688 l 7.6876,-189.883 c 0,-7.111 3.2672,-10.763 9.9938,-10.763 7.6876,0 11.5314,3.844 11.5314,11.532 l -6.9188,149.907 57.6568,-93.019 c 1.5375,-3.075 4.2282,-4.613 8.4563,-4.613 6.5345,0 10.1861,3.075 10.7626,9.225 l 6.9189,89.945 77.6445,-156.827 c 1.9219,-4.036 4.9969,-6.15 9.2251,-6.15 7.111,0 10.7626,3.652 10.7626,10.763 0,1.537 -0.3844,3.075 -0.7688,4.612 l -94.5572,190.652 c -2.114,3.652 -5.1891,5.382 -9.2251,5.382 -7.3032,0 -10.7626,-3.268 -10.7626,-9.994 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path256"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g256"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 384.95551,
    y: 122.51747,
    id: "use256"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6150.8305,-18960.832 c 7.111,0 10.7626,3.46 10.7626,9.994 0,7.303 -3.6516,10.763 -10.7626,10.763 h -89.9447 c -3.075,0 -5.7657,-0.961 -7.6876,-3.075 -1.5375,-1.922 -1.9219,-4.613 -0.7687,-7.688 l 51.5067,-192.958 c 1.5376,-4.997 4.997,-7.688 10.7626,-7.688 6.5345,0 9.9939,3.652 9.9939,10.763 0,1.153 0,2.114 0,3.075 l -47.663,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path257"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g257"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 384.95551,
    y: 125.51744,
    id: "use257"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6305.3507,-19045.395 h -57.6568 l -23.0627,84.563 h 73.8007 c 7.111,0 10.7626,3.46 10.7626,9.994 0,7.303 -3.6516,10.763 -10.7626,10.763 h -89.9446 c -3.075,0 -5.7657,-0.961 -7.6876,-3.075 -1.5375,-1.922 -1.9219,-4.613 -0.7688,-7.688 l 50.7381,-189.883 c 1.9218,-7.111 6.9188,-10.763 14.6064,-10.763 h 83.7945 c 7.111,0 10.7626,3.652 10.7626,10.763 0,7.303 -3.6516,10.763 -10.7626,10.763 h -79.182 l -16.9127,63.038 h 52.2755 c 6.5345,0 9.9939,3.651 9.9939,10.762 0,7.303 -3.4594,10.763 -9.9939,10.763 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path258"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g258"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 384.95551,
    y: 128.51741,
    id: "use258"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6398.3704,-19140.721 c 1.9219,-7.111 6.9188,-10.763 14.6064,-10.763 h 65.3444 c 10.7626,0 20.1799,4.613 28.4441,13.838 8.6485,9.225 13.0688,19.603 13.0688,30.75 0,3.075 -0.3843,5.958 -0.7687,8.457 l -28.444,105.319 c -9.8017,35.363 -32.8644,53.045 -69.1882,53.045 h -65.3444 c -3.0751,0 -5.7657,-0.961 -7.6876,-3.075 -1.5375,-1.922 -1.9219,-4.613 -0.7688,-7.688 z m 19.219,10.763 -45.3567,169.126 h 54.5818 c 9.2251,0 17.6814,-3.075 25.369,-9.225 8.0719,-6.15 13.4532,-13.838 16.1439,-23.063 l 28.444,-105.319 c 0.3844,-2.499 0.7688,-4.997 0.7688,-7.688 0,-7.111 -2.3063,-12.685 -6.9188,-16.913 -4.6126,-4.612 -10.7627,-6.918 -18.4502,-6.918 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 519.35937,163.35938 v 14.71875 h -6.23958 v -14.71875 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 511.52083,316.80209 v 97.91666 h -6.08333 v -97.91666 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00165233 -0.479777,-0.642277 -1.28186,-1.121444 l -0.796875,-0.317708 -0.802083,-0.161459 -0.796875,0.161459 -0.802084,0.317708 -0.802083,0.479167 -0.479167,0.64062467",
    transform: "matrix(0.75,0,0,0.75,383.51999,237.71999)",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,-0.00124567 0.478119,0.639379 1.280202,1.118546 2.082286,1.441463 2.879161,1.597713 3.681244,1.441463 4.478119,1.118546 5.280202,0.639379 5.759369,-0.00124567",
    transform: "matrix(0.75,0,0,0.75,379.2,311.04)",
    id: "path263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 508.47917,316.80209 v 97.91666",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path264"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g264"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 384.95551,
    y: 260.5177,
    id: "use264"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12956.834,-19053.851 c 9.226,4.228 13.838,13.453 13.838,27.675 0,4.228 -0.769,8.264 -2.306,12.3 l -5.381,20.756 c -6.151,23.64 -18.451,39.207 -36.901,46.895 -9.225,4.228 -19.988,6.15 -32.288,6.15 h -40.744 c -6.726,0 -9.994,-3.46 -9.994,-10.763 0,-6.534 3.268,-9.994 9.994,-9.994 h 46.894 c 9.225,0 17.682,-3.075 25.369,-9.225 8.072,-6.15 13.454,-13.838 16.144,-23.063 l 5.382,-20.756 c 0.961,-4.613 1.537,-8.649 1.537,-12.3 0,-12.685 -8.841,-19.219 -26.138,-19.219 h -18.45 c -7.303,0 -10.762,-3.46 -10.762,-10.763 0,-7.111 3.459,-10.762 10.762,-10.762 h 24.6 c 12.685,0 23.448,-4.997 32.288,-15.376 4.613,-4.996 7.688,-10.378 9.225,-16.143 0.385,-3.46 0.769,-6.535 0.769,-9.226 0,-14.798 -8.456,-22.293 -25.369,-22.293 h -40.744 c -7.303,0 -10.763,-3.46 -10.763,-10.763 0,-7.111 3.46,-10.763 10.763,-10.763 h 46.125 c 16.336,0 28.637,7.496 36.901,22.294 3.075,6.727 4.612,13.646 4.612,20.757 0,3.075 -0.384,6.534 -0.768,9.994 -6.151,23.062 -17.682,38.053 -34.595,44.588 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path265"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g265"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 384.95551,
    y: 263.63766,
    id: "use265"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13053.314,-18960.832 c 21.525,0 34.978,-10.762 40.744,-32.288 l 6.15,-20.756 c 0.961,-4.036 1.537,-8.072 1.537,-12.3 0,-12.685 -8.84,-19.219 -26.137,-19.219 h -33.057 l -13.838,52.275 c -1.153,3.652 -1.537,6.535 -1.537,8.457 0,6.726 2.306,12.3 6.919,16.912 4.997,4.613 11.531,6.919 19.219,6.919 z m -6.151,20.757 c -14.99,0 -26.714,-7.688 -35.362,-23.063 -4.229,-6.535 -6.15,-13.453 -6.15,-20.757 0,-3.075 0.384,-5.765 1.537,-8.456 l 16.913,-63.807 c 6.15,-23.447 16.528,-43.242 31.519,-59.194 16.336,-17.297 37.861,-29.213 64.575,-35.363 0.961,-0.384 1.922,-0.769 3.075,-0.769 6.535,0 9.994,3.652 9.994,10.763 0,6.15 -2.306,9.609 -6.918,9.994 -11.916,1.537 -23.64,5.958 -35.363,13.069 -21.526,13.453 -35.171,30.366 -40.744,50.738 h 31.519 c 11.723,0 21.525,3.843 29.212,11.531 8.072,7.688 12.3,17.681 12.3,29.982 0,4.228 -0.576,8.072 -1.537,11.531 l -5.381,20.756 c -6.727,24.601 -18.835,40.552 -36.132,47.663 -8.841,3.652 -19.795,5.382 -33.057,5.382 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path266"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g266"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 384.95551,
    y: 266.63763,
    id: "use266"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13267.797,-19043.858 -60.732,99.17 c -2.114,3.075 -5.189,4.613 -9.225,4.613 -3.075,0 -5.766,-0.961 -7.688,-3.075 -2.114,-2.499 -3.075,-4.997 -3.075,-7.688 l 7.688,-189.883 c 0,-7.111 3.267,-10.763 9.994,-10.763 7.687,0 11.531,3.844 11.531,11.532 l -6.919,149.907 57.657,-93.019 c 1.538,-3.075 4.228,-4.613 8.457,-4.613 6.534,0 10.186,3.075 10.762,9.225 l 6.919,89.945 77.644,-156.827 c 1.922,-4.036 4.997,-6.15 9.226,-6.15 7.111,0 10.762,3.652 10.762,10.763 0,1.537 -0.384,3.075 -0.769,4.612 l -94.557,190.652 c -2.114,3.652 -5.189,5.382 -9.225,5.382 -7.303,0 -10.762,-3.268 -10.762,-9.994 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path267"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g267"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 384.95551,
    y: 275.51755,
    id: "use267"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13678.506,-18960.832 c 7.111,0 10.762,3.46 10.762,9.994 0,7.303 -3.651,10.763 -10.762,10.763 h -89.945 c -3.075,0 -5.766,-0.961 -7.687,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 l 51.507,-192.958 c 1.537,-4.997 4.996,-7.688 10.762,-7.688 6.535,0 9.994,3.652 9.994,10.763 0,1.153 0,2.114 0,3.075 l -47.663,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path268"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g268"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 384.95551,
    y: 278.51752,
    id: "use268"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13833.026,-19045.395 h -57.657 l -23.063,84.563 h 73.801 c 7.111,0 10.763,3.46 10.763,9.994 0,7.303 -3.652,10.763 -10.763,10.763 h -89.944 c -3.075,0 -5.766,-0.961 -7.688,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 l 50.738,-189.883 c 1.922,-7.111 6.919,-10.763 14.607,-10.763 h 83.794 c 7.111,0 10.763,3.652 10.763,10.763 0,7.303 -3.652,10.763 -10.763,10.763 h -79.182 l -16.912,63.038 h 52.275 c 6.534,0 9.994,3.651 9.994,10.762 0,7.303 -3.46,10.763 -9.994,10.763 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path269"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g269"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 384.95551,
    y: 281.51749,
    id: "use269"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13926.046,-19140.721 c 1.922,-7.111 6.919,-10.763 14.606,-10.763 h 65.345 c 10.762,0 20.179,4.613 28.444,13.838 8.648,9.225 13.068,19.603 13.068,30.75 0,3.075 -0.384,5.958 -0.768,8.457 l -28.444,105.319 c -9.802,35.363 -32.865,53.045 -69.189,53.045 h -65.344 c -3.075,0 -5.766,-0.961 -7.688,-3.075 -1.537,-1.922 -1.921,-4.613 -0.768,-7.688 z m 19.219,10.763 -45.357,169.126 h 54.582 c 9.225,0 17.681,-3.075 25.369,-9.225 8.072,-6.15 13.453,-13.838 16.144,-23.063 l 28.444,-105.319 c 0.384,-2.499 0.768,-4.997 0.768,-7.688 0,-7.111 -2.306,-12.685 -6.918,-16.913 -4.613,-4.612 -10.763,-6.918 -18.451,-6.918 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 519.35937,367.35938 v 14.71875 h -6.23958 v -14.71875 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path271"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/План Пустий.cff209cbc528470d6c5130563e6471b0.svg";
export { ForwardRef as ReactComponent };